import Vue from 'vue'
import IcnRegion from '@/components/IcnRegion.vue'
import IcnOpportunities from '@/components/IcnOpportunities.vue'

if (document.querySelector("#app-icngateway-supplier") !== null) {
  new Vue({
    components: {
      IcnRegion,
    }
  }).$mount('#app-icngateway-supplier')
}

if (document.querySelector("#app-icngateway-opportunity") !== null) {
  new Vue({
    components: {
      IcnOpportunities
    }
  }).$mount('#app-icngateway-opportunity')
}
